import { Box, Tooltip, Typography } from "@mui/material"
import { isNil } from "lodash"
import { DragEvent, useState } from "react"
import { OotItemDto } from "../../ootr/hints/OotItemAutocomplete"
import { ItemLightDto } from "./ItemDataTypes"
export interface BaseItemProps {
    id: string
    image: string
    title?: string
    displayName?: boolean
    isObtained: boolean,
    tooltip?: string
    shadow?: boolean,
    onClick: React.MouseEventHandler<HTMLImageElement> | undefined,
    onRightClick?: React.MouseEventHandler<HTMLImageElement> | undefined
    imageComponent?: (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => JSX.Element,
    childItemImg?: string,
    childItemName?: string,
    displayChildItem?: true,
    setIsObtained?: (v: boolean) => void
    item?: ItemLightDto
    updateItem?: (i: ItemLightDto) => void
}

const BaseItem = (props: BaseItemProps) => {

    let [childItem, setChildItem] = useState<string | undefined>(props.item?.childItem ??  props.childItemImg)
    let [childItemName, setChildItemName] = useState<string | undefined>(props.item?.childItemName ?? props.childItemName)

    let childItemOverride = props.item?.childItem ?? childItem;
    let childItemNameOverride = props.item?.childItemName ?? childItemName;

    const onDrop = (e: DragEvent<HTMLDivElement>) => {

        const item: OotItemDto = JSON.parse(e.dataTransfer.getData('text/plain'))

        if(!isNil(item.lightItem) && !isNil(props.updateItem) && item.name.includes("Song"))
        {
            props.updateItem({...item.lightItem, isObtained: true, childItem: props.item?.img ?? "", childItemName: props.item?.title})
        }
        else
        {
            setChildItem(item.img);
            setChildItemName(item.name);
        }
    
    }

    const onDrag = (e: DragEvent<HTMLDivElement>) => {
        e.dataTransfer.setData("text/plain", JSON.stringify({ img: props.image, name: props.title, tags: [], childImage: childItem, childName: childItemName, lightItem: props.item } as OotItemDto))
        
        if(!isNil(props.setIsObtained) && !props.isObtained)
        {
            props.setIsObtained(true);
        }
    }


    
    return <Tooltip title={props.tooltip} placement="top" >
        <Box display="flex" flexDirection="column" justifyContent="center" onDragOver={(e) => { e.preventDefault(); }} onDragEnter={(e) => { e.preventDefault(); }}  onDrop={(e) => onDrop(e)}>
            <Box display="flex" sx={{ filter: !props.isObtained ? "grayscale(100%) brightness(0.6)" : "none", width: "none", justifyContent: "center", alignItems: "center" }}>
                {isNil(props.imageComponent) && <img draggable
                    onDragStart={onDrag} src={props.image} alt={props.title} onClick={props.onClick} onContextMenu={props.onRightClick} height="32px" width="32px" />}
                {!isNil(props.imageComponent) && <props.imageComponent onClick={props.onClick} onContextMenu={props.onRightClick} />}
            </Box>
            <Box justifyContent="center" display="flex" flexWrap={"wrap"}>
                {props.displayName && <Typography flexWrap={"wrap"} width={"32px"} textAlign={"center"}>{props.title}</Typography>}
            </Box>
            <Box sx={{ position: "absolute", bottom: "-15px", left: "8px" }} zIndex={999}>
                {!isNil(childItemOverride) && props.displayChildItem && <img onContextMenu={(e) => {
                    e.preventDefault(); setChildItem(undefined); setChildItemName(undefined);
                    if(!isNil(props.item) && !isNil(props.updateItem))
                        props.updateItem({...props.item, childItem: undefined, childItemName: undefined})
                }} src={childItemOverride} alt={childItemNameOverride} width={16} height={16} />}
            </Box>
        </Box>
    </Tooltip>
}

export default BaseItem